/* eslint-disable no-unused-expressions */
import React from 'react';
import './PostControlNoteDetail.css';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import {Waiter} from '.././WaitingSign/Waiting';
import {ControlDetailInfo} from '../ControlDetailInfo/ControlDetailInfo';
import {DocumentOnList} from '../documents';
import {mapNewAttachments, sortAttachmentsByOrderIndex} from '../documents/helpers';
import * as httpService from '../HttpService/HttpService';
import {sendLog} from '../HttpService/SendLog';
import PopUp from '.././PopUp/PopUp';
import {PDFDownloadLink} from '@react-pdf/renderer';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PdfNote from '../PdfPostControl/PdfPostControlNote';
import {isWTrakcieRealizacji} from "../ControlStateHelper";
import {errorMessageText} from "../HttpService/HttpService";
import {AuditDetail} from "../AuditDetail/AuditDetail";
import {draftjsToHTML} from '../WysiwygEditor/WysiwygHelpers';
import { isValidJson, extractJsonsWithPreText, rawToEditorContent, plainTextToEditorContent, mergeContentStates } from '../WysiwygEditor/WysiwygHelpers';
import { convertToRaw } from 'draft-js';
import { emptyEditorContentPlainText } from '../../consts/consts';

export const GET_CONTROL_LIST_DATA_REQUESTED = 'GET_CONTROL_LIST_DATA_REQUESTED';
export const GET_CONTROL_LIST_DATA_DONE = 'GET_CONTROL_LIST_DATA_DONE';
export const GET_CONTROL_LIST_DATA_FAILED = 'GET_CONTROL_LIST_DATA_FAILED';

export const createPdf = (controlData, noteData, noteNumber) => {
	return (
		<PdfNote control={controlData} infoNumber={noteNumber} infoData={noteData}>
		</PdfNote>
	)
};

class PostControlNoteDetail extends React.Component {

	noteId;
	controlId;

	constructor(props) {
		super(props);
		this.state = {
			isLocked: true,
			controlData: null,
			noteData: null,
			isWaiting: true,
			error: null
		}
	}

	componentDidMount() {
		this.noteId = this.props.match.params.noteId;
		this.controlId = this.props.match.params.controlId;
		const url = this.props.source === "my_controls" ? PropertyBucket.getMyControlDetailByControlId(this.controlId) : PropertyBucket.getPostControlDetailByControlId(this.controlId);
		let callPromise = httpService.getServicePromise(url, 'GET');
		callPromise.then(
			data => {
				let postControlDocument = data.postControlDocuments.find(el => el.postControlNote && el.postControlNote.id == this.noteId)?.postControlNote
				if (postControlDocument) {
					let attachmentsMap = mapNewAttachments(postControlDocument, data)
					this.setState({
						controlData: data,
						noteData: postControlDocument,
						attachments: attachmentsMap,
						isWaiting: false
					})
				}
				else {
					let unauthorized = errorMessageText(401)
					this.setState({
						isWaiting: false,
						error: unauthorized
					})
				}
			})
			.catch(error => {
				this.turnOffWaiter();
				this.setState({error: error});
			});
	}


	buildNoteHtml = (noteContent) => {
		try {
			let rawJsonString = '';
			if (isValidJson(noteContent)) { //noteContent is full JSON
				rawJsonString = noteContent;
			} else if (noteContent === emptyEditorContentPlainText) { //noteContent is equals to 'Brak uwag'
				const content = plainTextToEditorContent(noteContent);
				rawJsonString = JSON.stringify(convertToRaw(content));
			} else { //noteContent is mix of JSON chunks or plain text
				const jsonContentArray = extractJsonsWithPreText(noteContent);
				const statesArray = jsonContentArray.flatMap(({ pre, json }) => [
					plainTextToEditorContent(pre),
					rawToEditorContent(json)
				]);

				if(statesArray.length === 0) { // plain text
					const fallbackContent = plainTextToEditorContent(String(noteContent ?? ''));
					rawJsonString = JSON.stringify(convertToRaw(fallbackContent));
				} else { // mix of JSON chunks
					const mergedRaw = mergeContentStates(statesArray);
					rawJsonString = JSON.stringify(mergedRaw);
				}
			}

			return draftjsToHTML(rawJsonString);
		} catch (e) {
			return draftjsToHTML(noteContent);
		}
	}

	goBack = () => {
		this.props.history.goBack();
	};

	turnOffWaiter = () => {
		this.setState({
			isWaiting: false
		})
	};

	printContent = (control) => {
		let fileName = 'eKontrole-' + this.noteNumber + '.pdf';
		return <div>
			<button className='btn success-btn' id='pdf_img_container' onClick={() => { sendLog(null, null, fileName) }}>
				<span className="sr-only">Pobierz PDF</span>
				<PDFDownloadLink document={createPdf(this.state.controlData, this.state.noteData, this.noteNumber)} fileName={fileName}>
					{({ loading }) => (loading ? '' : (
						<>
							<PictureAsPdfIcon style={{ color: '#0d47a1', fontSize: 46 }} />
							<span className="sr-only">Kliknij, aby pobrać PDF</span>
						</>
					))}
				</PDFDownloadLink>
			</button>
			{isWTrakcieRealizacji(control) && <span className='red h5'>WERSJA ROBOCZA</span>}

			<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
			                                                                                  aria-hidden='true'
			                                                                                  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
			</button>
			<h3><span className='titleClass'>Notatka pokontrolna </span><span
				className='font-weight-bold'>{this.noteNumber}</span></h3>

			<ControlDetailInfo control={control}/>

			<div className='controlListBlocks'>
				<h4 className='mt-4'>Treść notatki</h4>
				<div dangerouslySetInnerHTML={{ __html: this.buildNoteHtml(this.state.noteData.noteContent) }} />
			</div>

			<div className='controlListBlocks'>
				<h4 className='mt-4'>Załączniki</h4>
				<div className='mb-5'>{this.renderAttachments()}</div>
			</div>

			<div className='controlListBlocks'>
				<h4 className='mt-4'>Dane audytowe</h4>
				{<AuditDetail
					auditData={{
						createdOn: this.state?.noteData?.dataCreatedOn,
						createdByLogin: this.state?.noteData?.dataCreatedByLogin,
						createdBy: this.state?.noteData?.dataCreatedBy,
						updatedOn: this.state?.noteData?.dataUpdatedOn,
						updatedByLogin: this.state?.noteData?.dataUpdatedByLogin,
						updatedBy: this.state?.noteData?.dataUpdatedBy,
					}}
				></AuditDetail>}
			</div>
		</div>;
	};

	closePopup() {
		this.setState({error: null})
	}

	renderAttachments() {
		if (!this.state.noteData?.attachments?.length) {
			return <p className='mb-5'>Brak załączników</p>
		}
		return (this.state.attachments || [])
			.sort(sortAttachmentsByOrderIndex)
			.map((attachment, index) => (
				<DocumentOnList
					document={attachment.document}
					key={attachment.id}
					index={index + 1}
					withIndexOnList
				/>
			))
	}

	render() {
		let control = this.state.controlData;
		if (control) {
			this.noteNumber = control.number + '-NOT';
		}

		let popUp;
		if (this.state.error !== null) {
			popUp = <PopUp title='Błąd'
						   type='error'
						   notification={this.state.error}
						   closePopUp={() => this.closePopup()}
			/>
		}

		return (
			<div id='post-control-note' className='post-control-note'>
				{control ? this.printContent(control) :
					<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
																									  aria-hidden='true'
																									  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
					</button>}
				{popUp ? popUp : null}
				<div id='waiter'><Waiter loading={this.state.isWaiting}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {}
};

export const PostControlNoteDetailProvider = connect(mapStateToProps, mapDispatchToProps)(PostControlNoteDetail);



